/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WhitepaperDto } from '../../models/whitepaper-dto';

export interface GetWhitepaper$Params {
  year?: number;
  company?: number;
}

export function getWhitepaper(http: HttpClient, rootUrl: string, params?: GetWhitepaper$Params, context?: HttpContext): Observable<StrictHttpResponse<WhitepaperDto>> {
  const rb = new RequestBuilder(rootUrl, getWhitepaper.PATH, 'get');
  if (params) {
    rb.query('year', params.year, {});
    rb.query('company', params.company, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WhitepaperDto>;
    })
  );
}

getWhitepaper.PATH = '/api/whitepaper';
